import { GetGeocodeParams } from "../types/requestInputs";
import { GeocodeResponse } from "../types/requestsOutputs";

export const getGeocode = async ({ address }: GetGeocodeParams): Promise<GeocodeResponse | null> => {
    try {
        const encodedAddress = encodeURIComponent(address);
        const response = await fetch(`https://nominatim.openstreetmap.org/search?q=${encodedAddress}&format=json`);
        const data = await response.json();

        if (data.length > 0) {
            return { lat: data[0].lat, lon: data[0].lon };
        } else {
            throw new Error("No results found");
        }
    } catch (error) {
        console.error("Error fetching geocode:", error);
        return null;
    }
};
